import React from "react";
import SEO from "../components/SEO";
import "../styles/Reviews.css";
import { useScrollReveal } from "../hooks/useScrollReveal";

const reviewsData = [
  {
    name: "Product Lead, Consumer App",
    review:
      "MacroMatrix improved our onboarding flow and release quality. We saw stronger retention after two update cycles.",
    rating: 5,
    image: "/assets/Rperson1.jpg",
  },
  {
    name: "Founder, Mobile Startup",
    review:
      "Clear communication and disciplined execution. Requirements were translated into a stable production product quickly.",
    rating: 5,
    image: "/assets/Rperson2.jpg",
  },
  {
    name: "Operations Manager, Gaming Studio",
    review:
      "Their LiveOps support and data-led iteration improved campaign outcomes and in-app engagement.",
    rating: 5,
    image: "/assets/Rperson5.jpg",
  },
];

const highlights = [
  "Consistent milestone delivery",
  "High communication responsiveness",
  "Strong product and engineering alignment",
];

function Reviews() {
  useScrollReveal();
  return (
    <div className="reviews">
      <SEO title="Client Reviews" description="What our clients say about working with MacroMatrix — feedback on product delivery, engineering quality, and growth results." path="/reviews" />
      <section className="reviews-header">
        <h2>Client Feedback</h2>
        <p className="reviews-subtitle">
          Results-focused collaboration across product, engineering, and growth.
        </p>
      </section>

      <section className="review-list reveal">
        {reviewsData.map((review) => (
          <article className="review-item" key={review.name}>
            <img src={review.image} alt={review.name} loading="lazy" />
            <h3>{review.name}</h3>
            <p>"{review.review}"</p>
            <div className="star-rating">{Array(review.rating).fill("★").join("")}</div>
          </article>
        ))}
      </section>

      <section className="reviews-highlights reveal">
        <h3>What Clients Commonly Mention</h3>
        <div className="highlight-list">
          {highlights.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </div>
      </section>
    </div>
  );
}

export default Reviews;
